import { Model } from 'redux-orm'
import axiosInstance from 'api/axios.config'

class BaseModel extends Model {
  static findAll (params) {
    return axiosInstance.get(this.apiPath, { params })
  }
}

export default BaseModel
